module.exports = __webpack_public_path__ + "img/code_phone.c55eb3bf.png";